import { Text } from '@chakra-ui/react';
import cn from 'classnames';
import React from 'react';

import { VehicleInfoTableOption } from '@/types/details-car/details-car.types';
import { CarFilter } from '@/types/filters/filters.types';

import styles from './filter-blocks.module.scss';

export const FilterLabel: React.FC<{ label: string }> = ({ label }) => {
  return (
    <div className={styles.filterLabel}>
      <Text className={styles.labelText}>{label}</Text>
    </div>
  );
};

export const FilterBlock: React.FC<{
  filter: CarFilter | VehicleInfoTableOption;
  onClick: (filter: CarFilter | VehicleInfoTableOption) => void;
  className?: string;
}> = ({ filter, onClick, className }) => {
  return (
    <div
      className={cn(styles.filterBlock, className, {
        [styles.selected as string]: filter.isSelected,
        [styles.disabled as string]: filter.isDisabled,
      })}
      onClick={() => onClick(filter)}
    >
      {filter.name}
    </div>
  );
};

export const FilterBlocks: React.FC<{
  label: string;
  filters: CarFilter[];
  onSelect: (filterId: number) => void;
}> = ({ label, filters, onSelect }) => {
  return (
    <>
      <FilterLabel label={label} />
      <div className={styles.filterBlocks}>
        {filters.map((filter) => (
          <FilterBlock
            key={filter.id}
            filter={filter}
            onClick={(filter) => {
              onSelect(filter.id);
            }}
          />
        ))}
      </div>
    </>
  );
};
